module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/xp8Y1V/media/FC-9781035851768.jpg?1718732527110",
      "alt": "This image is the cover for the book Parvon Zin Koban Hunter Book 2: Return of the Anunnaki"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Parvon Zin Koban Hunter Book 2: Return of the Anunnaki\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("In Parvon Zin Koban Hunter Book 2: Return of the Anunnaki, the ancient promise of the Anunnaki looms large – their prophesied return to the Adamu, the beings they crafted, has come to pass. However, the sight that greets them sparks divine ire. The Adamu, once compliant subjects, have diverged from their intended path, embracing rebellion over subservience. Faced with this insubordination, the Anunnaki’s verdict is absolute and merciless: the eradication of their wayward creations. As the Anunnaki’s disdain for defiance knows no bounds, they are prepared to extinguish the rogue Adamu without exception. A cosmic conflict looms, and the fate of an entire species hangs in the balance.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      William C. Young\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("William C. Young is an alternative history and sci-fi buff who decided to put his passion onto paper. He lives in a quiet corner of Perth, Western Australia, and enjoys the many bounties of this great country.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Austin Macauley Publishers\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b7db194","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0